module.exports = __webpack_public_path__ + "static/img/name.59d550f5.png";